<app-dialog
  #dialog
  [key]="'modal-derivative-mtm-results'"
  [action]="'derivative-mtm-results'"
  [headerTheme]="'simple'"
  [showMaximizeButton]="true"
  [startMaximized]="true"
  [title]="'Mark to Market (MtM)'"
  [icon]="'pi pi-chart-line'"
  [maxWidth]="'90vw'"
  [minHeight]="'50vh'"
  [menuItems]="menuItems"
  (onClose)="close()">
  <div class="mtm-results" *ngIf="data">
    <div class="instrument-block" *ngIf="getNdfCapItems().length">
      <h3 class="instrument-title">NDF com CAP</h3>
      <app-table
        [items]="getNdfCapItems()"
        [columnDefinitions]="ndfCapColumns"
        [sortable]="true"
        [hasPagination]="false"
        [showSearch]="false"
        [ellipsisMenuConfig]="{ enabled: false }"
        (sendTableSort)="handleTableSort($event, 'ndfCap')">
        <ng-template appNamedTemplate="idReferencia" let-item>
          <a class="text-primary cursor-pointer" (click)="navigateToDerivative(item)"
            >{{ item.idReferencia }}</a
          >
        </ng-template>
        <ng-template appNamedTemplate="origemOperacao" let-item>
          <a class="text-primary cursor-pointer" (click)="openOriginDetails(item)"
            >{{ item.origemOperacao }}</a
          >
        </ng-template>
        <ng-template appNamedTemplate="notionalRound" let-item>
          {{ (item.notionalRound !== undefined && item.notionalRound !== null ? item.notionalRound :
          item.notional) | vaultFormatCurrency: 2 }}
        </ng-template>
        <ng-template appNamedTemplate="saldoMTMRound" let-item>
          @if(item.mtmDetails?.erro) { {{ item.mtmDetails.erro }} } @else { {{ item.saldoMTMRound|
          vaultFormatCurrency: 2 }} }
        </ng-template>
        <ng-template appNamedTemplate="valorMercadoRound" let-item>
          {{ (item.valorMercadoRound !== undefined && item.valorMercadoRound !== null ?
          item.valorMercadoRound : item.valorMercado) | vaultFormatCurrency: 2 }}
        </ng-template>
        <ng-template appNamedTemplate [isFooter]="true" let-items>
          <td [attr.colspan]="ndfCapColumns.length" class="p-2">
            <div class="d-flex justify-content-end fw-bold">
              Saldo Total MTM&nbsp;&nbsp;{{ getCapTotal() | vaultFormatCurrency: 2 }}
            </div>
          </td>
        </ng-template>
      </app-table>
    </div>

    <div class="instrument-block" *ngIf="getNdfVanillaItems().length">
      <h3 class="instrument-title">NDF Vanilla</h3>
      <app-table
        [items]="getNdfVanillaItems()"
        [columnDefinitions]="ndfVanillaColumns"
        [sortable]="true"
        [hasPagination]="false"
        [showSearch]="false"
        [ellipsisMenuConfig]="{ enabled: false }"
        (sendTableSort)="handleTableSort($event, 'ndfVanilla')">
        <ng-template appNamedTemplate="idReferencia" let-item>
          <a class="text-primary cursor-pointer" (click)="navigateToDerivative(item)"
            >{{ item.idReferencia }}</a
          >
        </ng-template>
        <ng-template appNamedTemplate="origemOperacao" let-item>
          <a class="text-primary cursor-pointer" (click)="openOriginDetails(item)"
            >{{ item.origemOperacao }}</a
          >
        </ng-template>
        <ng-template appNamedTemplate="saldoMTMRound" let-item>
          @if(item.mtmDetails?.erro) { {{ item.mtmDetails.erro }} } @else { {{ item.saldoMTMRound|
          vaultFormatCurrency: 2 }} }
        </ng-template>
        <ng-template appNamedTemplate="notionalRound" let-item>
          {{ (item.notionalRound !== undefined && item.notionalRound !== null ? item.notionalRound :
          item.notional) | vaultFormatCurrency: 2 }}
        </ng-template>
        <ng-template appNamedTemplate="valorMercadoRound" let-item>
          {{ (item.valorMercadoRound !== undefined && item.valorMercadoRound !== null ?
          item.valorMercadoRound : item.valorMercado) | vaultFormatCurrency: 2 }}
        </ng-template>
        <ng-template appNamedTemplate [isFooter]="true" let-items>
          <td [attr.colspan]="ndfVanillaColumns.length" class="p-2">
            <div class="d-flex justify-content-end fw-bold">
              Saldo Total MTM&nbsp;&nbsp;{{ getVanillaTotal() | vaultFormatCurrency: 2 }}
            </div>
          </td>
        </ng-template>
      </app-table>
    </div>

    <div class="instrument-block" *ngIf="getOpcoesItems().length">
      <h3 class="instrument-title">Call Spread</h3>
      <app-table
        [items]="getOpcoesItems()"
        [columnDefinitions]="opcoesColumns"
        [sortable]="true"
        [hasPagination]="false"
        [showSearch]="false"
        [ellipsisMenuConfig]="{ enabled: false }"
        (sendTableSort)="handleTableSort($event, 'opcoes')">
        <ng-template appNamedTemplate="idReferencia" let-item>
          <a class="text-primary cursor-pointer" (click)="navigateToDerivative(item)"
            >{{ item.idReferencia }}</a
          >
        </ng-template>
        <ng-template appNamedTemplate="origemOperacao" let-item>
          <a class="text-primary cursor-pointer" (click)="openOriginDetails(item)"
            >{{ item.origemOperacao }}</a
          >
        </ng-template>
        <ng-template appNamedTemplate="saldoMTMRound" let-item>
          @if(item.mtmDetails?.erro) { {{ item.mtmDetails.erro }} } @else { {{ item.saldoMTMRound|
          vaultFormatCurrency: 2 }} }
        </ng-template>
        <ng-template appNamedTemplate="notionalRound" let-item>
          {{ (item.notionalRound !== undefined && item.notionalRound !== null ? item.notionalRound :
          item.notional) | vaultFormatCurrency: 2 }}
        </ng-template>
        <ng-template appNamedTemplate="valorMercadoRound" let-item>
          {{ (item.valorMercadoRound !== undefined && item.valorMercadoRound !== null ?
          item.valorMercadoRound : item.valorMercado) | vaultFormatCurrency: 2 }}
        </ng-template>
        <ng-template appNamedTemplate [isFooter]="true" let-items>
          <td [attr.colspan]="opcoesColumns.length" class="p-2">
            <div class="d-flex justify-content-end fw-bold">
              Saldo Total MTM&nbsp;&nbsp;{{ getOpcoesTotal() | vaultFormatCurrency: 2 }}
            </div>
          </td>
        </ng-template>
      </app-table>
    </div>

    <div
      class="empty-state"
      *ngIf="!getNdfCapItems().length && !getNdfVanillaItems().length && !getOpcoesItems().length">
      <i class="pi pi-info-circle"></i>
      <p>Nenhum dado para exibir.</p>
    </div>
  </div>

  <ng-template #footer></ng-template>
</app-dialog>

<ng-container>
  <app-modal-comex-operation-details #comexDetailsModal></app-modal-comex-operation-details>
  <app-modal-loan-details #loanDetailsModal></app-modal-loan-details>
</ng-container>
